// extracted by mini-css-extract-plugin
module.exports = {"new-expense":"NewExpense_new-expense__2OVll","card-appears":"NewExpense_card-appears__28z5B"};